import { render, staticRenderFns } from "./VContainer.vue?vue&type=template&id=78cdb6d0&"
import script from "./VContainer.vue?vue&type=script&lang=js&"
export * from "./VContainer.vue?vue&type=script&lang=js&"
import style0 from "./VContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports